import doc                      from '@widesk-core/decorators/doc';
import model                    from '@widesk-core/decorators/model';
import NotificationServiceModel from '@/models/NotificationServiceModel';

@model.urnResource('mercure_token_request')
@doc.path('/mercure_token_requests/{?id}')
export default class MercureTokenRequest extends NotificationServiceModel {
	private declare _tsFilters: unknown;
	private declare _tsSorts: unknown;

	@doc.string declare token: string;
}